import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <header
      data-testid="site-header"
      className="relative z-40 w-full"
      style={{ backgroundColor: "hsl(var(--ivory))" }}
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 py-6 flex items-center justify-between rule-bottom">
        <Link
          to="/"
          data-testid="brand-logo-link"
          className="flex items-center gap-3"
        >
          <span
            aria-hidden
            className="inline-block"
            style={{
              width: 28,
              height: 28,
              border: "1px solid hsl(var(--plum))",
              transform: "rotate(45deg)",
            }}
          />
          <span className="font-serif text-2xl tracking-tight">
            Mentorship<span style={{ color: "hsl(var(--gold))" }}> · </span>Fit
          </span>
        </Link>
        <nav className="flex items-center gap-8 overline">
          {!isAdmin && (
            <>
              <Link
                data-testid="nav-quiz-link"
                to="/quiz"
                className="hover:text-[hsl(var(--gold))] transition-colors"
              >
                Start Quiz
              </Link>
              <Link
                data-testid="nav-admin-link"
                to="/admin/login"
                className="hover:text-[hsl(var(--gold))] transition-colors hidden sm:inline"
              >
                Admin
              </Link>
            </>
          )}
          {isAdmin && (
            <Link
              data-testid="nav-home-link"
              to="/"
              className="hover:text-[hsl(var(--gold))] transition-colors"
            >
              Back to site
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
